import _ from 'lodash';
import { getField, updateField } from 'vuex-map-fields';
const state = {
    procesos: [
        {
            tipo: 'comprar_vehiculo',
            active: false,
        },
        {
            tipo: 'conseguir_vehiculo',
            active: false,
            rango_precio: [],
            rango_anio: [],
            tipo_busqueda: null
        },
        {
            tipo: 'credito_vehiculo',
            active: false,
            actividad: '',
            tiempo_actividad: '',
            plazo: '',
            ingresos: '',
            financiar: ''
        },
        {
            tipo: 'retoma_consignacion',
            active: false,
            kilometraje: 0,
            precio_estimado: 0,
            marca_id: '',
            anio_id: '',
            linea_id: '',
            version_id: ''
        }
    ],
    id_proceso: '',
    status_modal: false,
    modal_proceso: {
        _id: '',
        tipo: '',
        titulo: '',
        placa: '',
        asesor: {},
        servicios: [],
        negocio: {
            estado_principal: {},
            tab_status: {},
            proceso: {}
        }
    }
};
const mutations = {
    updateField,
    addProceso: (state, payload) => {
        state.procesos.push(payload);
    },
    updateProceso: (state, payload) => {
        state.id_proceso = payload;
    },
    openProceso: (state, payload) => {
        if(payload.first_time){
            state.status_modal = !state.status_modal;   
        }
        state.modal_proceso = {
            ...state.modal_proceso,
            _id: payload._id,
            tipo: payload.tipo,
            titulo: payload.titulo,
            placa: payload.placa,
            asesor: payload.asesor,
            servicios: payload.servicios,
            negocio: {
                ...state.modal_proceso.negocio, ...payload.negocio
            }
        }
    },
    closeProceso: (state) => {
        state.status_modal = !state.status_modal;
    },
    updateStep: (state, payload) => {
        state.modal_proceso.negocio.estado_principal = payload;
    }
};
const getters = {
    getField,
};
export default {
    namespaced: true,
    state,
    mutations,
    getters
}
